import React, {useState} from 'react';
import {CardContent, Modal, Paper} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Trans} from "react-i18next";
import functionHandler from "../../utils/functionHandler";
import ImageLoader from "../../components/imageLoader/ImageLoader";
import {Add, EditOutlined} from "@mui/icons-material";
import ParamTypes from "../../productParamHandler/paramTypes";
import Button from "@mui/material/Button";
import hash from "object-hash";
import CartManager from "../../managers/cartManager/cartManager";

function SelectedCustomDesignsWithFiles({cart}) {
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [selectedParam, setSelectedParam] = useState(null);
    const [newValue, setNewValue] = useState(null);

    const paramChange = (id, value) => {
        setNewValue(value);
    }

    const handleOpenModal = (item, id) => {
        setSelectedItem(item);
        setSelectedParam(item?.product?.params?.filter(param => param?.key === 'file')?.[0]);
        setSelectedItemId(id);
    }

    const filter = (items, key) => {
        return items[key]?.params?.hasOwnProperty('file');
    }

    const getPath = (item) => {
        if (item.params.file.path) {
            return functionHandler.getFunctionUrl(`/dep/thumbnail%2F${item.params.file.path.replace('svg', 'png')}`);
        }

        return item.product.images[0].thumbnail || item.product.images[0].src;
    }

    const getFallbackPath = (item) => {
        if (item.params.file.path) {
            return functionHandler.getFunctionUrl(`/dep/${item.params.file.path.replace('svg', 'png')}`);
        }

        return item.product.images[0].src;
    }

    const onSubmit = () => {
        if (newValue && hash(selectedItem.params.file) !== hash(newValue)) {
            CartManager.changeParam(selectedItemId, newValue, selectedParam.key, selectedItem.productId);
        }

        handleCloseModal();
    }

    const getDesigns = () => {
        const items = cart?.items || {};
        return Object.keys(items).filter(key => filter(items, key)).map(key => {
            const item = items[key];

            if (item.params.file.path) {
                return <Grid key={key} sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    <ImageLoader
                        src={getPath(item)}
                        fallbackSrc={getFallbackPath(item)}
                        sx={{
                            width: 82,
                            height: 82,
                            borderRadius: '50%',
                            border: '2px dashed',
                            borderColor: 'primary.main',
                            overflow: 'hidden'
                        }}/>
                    x{item.nr}
                    <CardContent className="" sx={{
                        width: 84,
                        height: 84,
                        borderRadius: '50%',
                        cursor: 'pointer',
                        backgroundColor: 'rgba(255,255,255,0.7)',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        opacity: 0,
                        "&:hover": {
                            opacity: 1,
                        }
                    }} onClick={() => handleOpenModal(item, key)}>
                        <EditOutlined
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            }}
                            color="secondary"/>
                    </CardContent>
                </Grid>
            }

            return <CardContent sx={{
                width: 82,
                height: 82,
                borderRadius: '50%',
                cursor: 'pointer',
                border: '2px dashed',
                borderColor: 'warning.light'
            }} onClick={() => handleOpenModal(item, key)}>
                <Add sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                }}/>
            </CardContent>
        });
    }

    const handleCloseModal = () => {
        setSelectedItem(null);
        setNewValue(null);
        setSelectedItemId(null);
        setSelectedParam(null);
    }

    const designs = getDesigns();
    return (designs.length ?
            <Box>
                <CardContent sx={{px: 0}}>
                    <Typography>Per cm² - <Trans i18nKey={'designsPage.justRight'}/></Typography>
                </CardContent>
                <Grid container gap={1}>{designs}</Grid>
                <Modal
                    open={Boolean(selectedItem)}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                >
                    <Paper sx={{
                        width: '300px',
                        padding: 2
                    }}>
                        <Grid
                            container
                            flexDirection="column"
                            justifyContent="space-between"
                        >
                            <CardContent sx={{
                                '& div.colors-param-container': {
                                    justifyContent: 'initial'
                                }
                            }}>
                                {selectedItem ? ParamTypes.GET_COMPONENT(selectedParam, paramChange, newValue || selectedItem.params.file, true) : ''}
                            </CardContent>
                            <Box sx={{justifyContent: 'flex-end', display: 'flex'}}>
                                <Button variant={"contained"} sx={{ml: 2}} onClick={onSubmit}>
                                    <Trans i18nKey={'buttons.submit'}/>
                                </Button>
                            </Box>
                        </Grid>
                    </Paper>
                </Modal>
            </Box> : ''
    );
}

export default SelectedCustomDesignsWithFiles;
